import React from 'react'

export default function Tabs({
  pages
}) {
  if (!pages.length) {
    return '';
  }

  return (
    <div className="tabs-container">
      { pages.map((page, key) => {
        let isActive = page.active ? "active-tab" : "";

        return (
          <div key={key} className={"tab-container " + isActive} onClick={() => {
            if (page.onClick) {
              page.onClick();
            }
          }}>
            { page.title }
          </div>
        )
      })}
      <div className="tabs-border"></div>
    </div>
  )
}
